import PANE from '../../../../../APP/page/pane/PANE.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
export default class PANE_Home_Pages_One extends PANE {
    constructor(node, model) {
        super(node, model);
        this.addClass('full-frame');
        this.addHeading(heading(1, 'Let\'s Talk!'));
        this.addP(text('How can we help you?'));
        let endpoint = 'core/messagebus/version';
        this.logInfo('Initial Endpoint', endpoint);
        // TODO: Create a contact form
        // let divForm = this
        // TODO: Add contact information
        // TODO: Add a chat widget or redirect to chat.spoonmedia.ca
        // TODO: Add a text widget to send SMS
        // TODO: Add a calendar widget to book appointments
    }
}
